import React, { Fragment, useContext } from "react";

import { PropTypes } from "prop-types";

import { Box, Grid, Typography } from "@mui/material";
import EnergyFlow from "../flow/EnergyFlow";
import WallboxCard from "../wallbox/WallboxCard";
import HeatpumpCard from "../heatpump/HeatpumpCard";
import { checkUrlAccessRights } from "../../navigation";
import useWallboxDemoData from "../../../shared/hooks/flow/demo/useWallboxDemoData";
import useHeatpumpDemoData from "../../../shared/hooks/flow/demo/useHeatpumpDemoData";
import useFlowDemoData from "../../../shared/hooks/flow/demo/useFlowDemoData";
import {
  chargingHistoryHeader,
  chargingHistoryTexts,
  flowHeader,
  flowHistoryDataExportTexts,
  flowHistoryHeader,
  flowHistoryTexts,
  flowTexts,
  heatpumpFlowTexts,
  sgReadyHistoryHeader,
  sgReadyTexts,
  wallboxFlowTexts,
} from "../../../shared/constants/demo";
import { AuthContext } from "../../../shared/contexts/AuthContext";
import Typographies from "./Typographies";

export default function PageInstructions({ location }) {
  const { user } = useContext(AuthContext);

  const {
    wallbox,
    setLocked,
    setHybridCharging,
    setSurplusCharging,
    addLockTime,
    deleteLockTime,
  } = useWallboxDemoData();
  const { heatpump, setSgReadySoc, setSgReadyTime } = useHeatpumpDemoData();

  const { flowData } = useFlowDemoData();

  const typographyContext = { location };

  return (
    <Fragment>
      <Grid container justify="center">
        <Grid
          key="flow-instructions"
          xs={12}
          item
          justifyContent="center"
          alignItems="center"
          marginY={3}
        >
          <Typography align="center" fontSize="h6.fontSize" color="secondary">
            {flowHeader}
          </Typography>
          <Grid container justify="center">
            <Grid
              xs={12}
              lg={8}
              item
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box>
                <Typographies
                  typographyData={flowTexts}
                  context={typographyContext}
                />
              </Box>
            </Grid>
            <Grid xs={12} lg={4} item>
              <EnergyFlow
                flowheight={{ xs: "300px", lg: "400px" }}
                flowwidth={"100%"}
                flowData={flowData}
              />
            </Grid>
          </Grid>
        </Grid>
        {location?.wallbox_set?.length > 0 && (
          <Grid
            key="wallbox-control-instructions"
            xs={12}
            sm={12}
            md={12}
            item
            justifyContent="center"
            alignItems="center"
            marginY={3}
          >
            <Grid container justify="center" alignItems="center" spacing={2}>
              <Grid xs={12} lg={9} item>
                <Typographies
                  typographyData={wallboxFlowTexts}
                  context={typographyContext}
                />
              </Grid>
              <Grid xs={12} lg={3} item>
                <WallboxCard
                  wallbox={wallbox}
                  editName={null}
                  setLocked={setLocked}
                  setHybridCharging={setHybridCharging}
                  setSurplusCharging={setSurplusCharging}
                  addLockTime={addLockTime}
                  deleteLockTime={deleteLockTime}
                  infoText={false}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        {location?.heatpump_set?.length > 0 && (
          <Grid
            key="heatpump-control-instructions"
            xs={12}
            sm={12}
            md={12}
            item
            justifyContent="center"
            alignItems="center"
            marginY={3}
          >
            <Grid container justify="center" alignItems="center" spacing={2}>
              <Grid xs={12} lg={9} item>
                <Typographies
                  typographyData={heatpumpFlowTexts}
                  context={typographyContext}
                />
              </Grid>
              <Grid xs={12} lg={3} item>
                <HeatpumpCard
                  heatpump={heatpump}
                  editName={null}
                  setSgReadyTime={setSgReadyTime}
                  setSgReadySoc={setSgReadySoc}
                  infoText={false}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        {checkUrlAccessRights(user, "flowhistorie") && (
          <Grid
            xs={12}
            sm={12}
            md={12}
            item
            justifyContent="center"
            alignItems="center"
            marginY={3}
          >
            <Typography align="center" fontSize="h6.fontSize" color="secondary">
              {flowHistoryHeader}
            </Typography>
            <Typographies
              typographyData={flowHistoryTexts}
              context={typographyContext}
            />
            <Typographies
              typographyData={flowHistoryDataExportTexts}
              context={typographyContext}
            />
          </Grid>
        )}
        {checkUrlAccessRights(user, "ladehistorie") && (
          <Grid
            xs={12}
            sm={12}
            md={12}
            item
            justifyContent="center"
            alignItems="center"
            marginY={3}
          >
            <Typography align="center" fontSize="h6.fontSize" color="secondary">
              {chargingHistoryHeader}
            </Typography>
            <Typographies
              typographyData={chargingHistoryTexts}
              context={typographyContext}
            />
          </Grid>
        )}
        {checkUrlAccessRights(user, "waermepumpe") && (
          <Grid
            xs={12}
            sm={12}
            md={12}
            item
            justifyContent="center"
            alignItems="center"
            marginY={3}
          >
            <Typography align="center" fontSize="h6.fontSize" color="secondary">
              {sgReadyHistoryHeader}
            </Typography>
            <Typographies
              typographyData={sgReadyTexts}
              context={typographyContext}
            />
          </Grid>
        )}
      </Grid>
    </Fragment>
  );
}

PageInstructions.propTypes = {
  location: PropTypes.object,
};
